<section>
  <a
    matButton
    class="primary-button back-btn"
    data-test-id="back-to-overview"
    [routerLink]="['/', 'my-account', 'services']">
    <mat-icon>chevron_left</mat-icon>
    Back to overview
  </a>

  @if (service(); as service) {
    <div class="service-container">
      <div class="left">
        @if (service.image) {
          <div class="img-preview">
            <picture>
              <img
                [src]="service.image | sanitizeSrc"
                [alt]="'Service icon'" />
            </picture>
          </div>
        }
      </div>
      <div class="right">
        <div class="header-info">
          <div>
            <h4>{{ service.name }}</h4>
            <div class="service-status">
              <span
                [floatUi]="tooltip"
                [showTrigger]="popTriggers.hover"
                [placement]="popPlacements.RIGHT"
                [timeoutAfterShow]="3000"
                [showDelay]="100"
                [disabled]="service.status !== serviceLogicalStatuses.ACTIVE"
                [class]="service.status | serviceLogicalStatus">
                {{ service.status | uppercase }}
              </span>
              @if (service.status === serviceLogicalStatuses.ACTIVE && service.timestamp) {
                <small>Subscribed on {{ service.timestamp | date: 'mediumDate' }}</small>
              }
            </div>
          </div>
          @if (service.status === serviceLogicalStatuses.INACTIVE) {
            <button
              matButton="filled"
              class="primary-button"
              data-test-id="subscribe-button"
              (click)="activateService()">
              subscribe
            </button>
          }
        </div>
        <div class="main-info">
          @if (service.description) {
            <div class="info-item default-padding">
              <ume-plain-html [html]="service.description"></ume-plain-html>
            </div>
          }
          <div class="info-item flex-column default-padding">
            @if (service.benefits) {
              <h5>Benefits</h5>
              <ume-plain-html [html]="service.benefits"></ume-plain-html>
            }
          </div>
        </div>

        @if (terms().length) {
          <div class="terms-list">
            <h4>Linked terms and conditions</h4>
            <ume-offering-terms-and-conditions-list
              [terms]="terms()"></ume-offering-terms-and-conditions-list>
          </div>
        }
      </div>
    </div>
  }
</section>

<float-ui-content #tooltip>
  <span>
    To deactivate the service, please contact
    <a href="mailto:support@ume.solutions">support&#64;ume.solutions</a>
    .
  </span>
</float-ui-content>
